import { getIn } from '@client/shared/utils/immutableUtils/immutableUtils';

export function getSortedObject(obj) {
  const ordered = {};
  Object.keys(obj)
    .sort()
    .forEach(function(key) {
      ordered[key] = obj[key];
    });
  return ordered;
}

export function areArraysEqual(value, other) {
  // Get the value type
  var type = Object.prototype.toString.call(value);

  // If the two objects are not the same type, return false
  if (type !== Object.prototype.toString.call(other)) return false;

  // If items are not an object or array, return false
  if (['[object Array]', '[object Object]'].indexOf(type) < 0) return false;

  // Compare the length of the length of the two items
  var valueLen =
    type === '[object Array]' ? value.length : Object.keys(value).length;
  var otherLen =
    type === '[object Array]' ? other.length : Object.keys(other).length;
  if (valueLen !== otherLen) return false;

  // Compare two items
  var compare = function(item1, item2) {
    var isEqual = function(value, other) {
      // Get the value type
      var type = Object.prototype.toString.call(value);

      // If the two objects are not the same type, return false
      if (type !== Object.prototype.toString.call(other)) return false;

      // If items are not an object or array, return false
      if (['[object Array]', '[object Object]'].indexOf(type) < 0) return false;

      // Compare the length of the length of the two items
      var valueLen =
        type === '[object Array]' ? value.length : Object.keys(value).length;
      var otherLen =
        type === '[object Array]' ? other.length : Object.keys(other).length;
      if (valueLen !== otherLen) return false;

      // Compare two items
      var compare = function(item1, item2) {
        // Get the object type
        var itemType = Object.prototype.toString.call(item1);

        // If an object or array, compare recursively
        if (['[object Array]', '[object Object]'].indexOf(itemType) >= 0) {
          if (!isEqual(item1, item2)) return false;
        }

        // Otherwise, do a simple comparison
        else {
          // If the two items are not the same type, return false
          if (itemType !== Object.prototype.toString.call(item2)) return false;

          // Else if it's a function, convert to a string and compare
          // Otherwise, just compare
          if (itemType === '[object Function]') {
            if (item1.toString() !== item2.toString()) return false;
          } else {
            if (item1 !== item2) return false;
          }
        }
      };

      // Compare properties
      if (type === '[object Array]') {
        for (var i = 0; i < valueLen; i++) {
          if (compare(value[i], other[i]) === false) return false;
        }
      } else {
        for (var key in value) {
          if (value.hasOwnProperty(key)) {
            if (compare(value[key], other[key]) === false) return false;
          }
        }
      }

      // If nothing failed, return true
      return true;
    };

    // Get the object type
    var itemType = Object.prototype.toString.call(item1);

    // If an object or array, compare recursively
    if (['[object Array]', '[object Object]'].indexOf(itemType) >= 0) {
      if (!isEqual(item1, item2)) return false;
    }

    // Otherwise, do a simple comparison
    else {
      // If the two items are not the same type, return false
      if (itemType !== Object.prototype.toString.call(item2)) return false;

      // Else if it's a function, convert to a string and compare
      // Otherwise, just compare
      if (itemType === '[object Function]') {
        if (item1.toString() !== item2.toString()) return false;
      } else {
        if (item1 !== item2) return false;
      }
    }
  };

  // Compare properties
  if (type === '[object Array]') {
    for (var i = 0; i < valueLen; i++) {
      if (compare(value[i], other[i]) === false) return false;
    }
  } else {
    for (var key in value) {
      if (value.hasOwnProperty(key)) {
        if (compare(value[key], other[key]) === false) return false;
      }
    }
  }

  // If nothing failed, return true
  return true;
}

export function toggleArrayValue(array, value) {
  var index = array.indexOf(value);

  if (index === -1) {
    array.push(value);
  } else {
    array.splice(index, 1);
  }

  return array;
}

export function immutablePush(arr, newEntry) {
  return [...arr, newEntry];
}

// It basically add an item to a list If item exists it updates it with new value,
// otherwise it just adds the item to the list, ie. The list shall not have any duplicated items.
export function setToArray(array = [], mapToAdd = {}, objUniqueField = '') {
  const indexToUpdate = array.findIndex((arrayItem) => {
    return arrayItem[objUniqueField] === mapToAdd[objUniqueField];
  });

  if (indexToUpdate === -1) {
    // mapToAdd doesn't exists in list
    return immutablePush(array, mapToAdd);
  } else {
    // mapToAdd obj exists in list. Update old obj with mapToAdd
    const firstPart = immutablePush(array.slice(0, indexToUpdate), mapToAdd);
    const secondPart = array.slice(indexToUpdate + 1);
    return mergeArrays(firstPart, secondPart);
  }
}

// Returns a new array, it doesnt modify passed in array.
export function arrayRemoveNonPrim(
  arr = [],
  objToRemove = {},
  objUniqueField = ''
) {
  const indexToRemove = arr.findIndex((arrayItem) => {
    return arrayItem[objUniqueField] === objToRemove[objUniqueField];
  });

  if (indexToRemove > -1) {
    const firstPart = arr.slice(0, indexToRemove);
    const secondPart = arr.slice(indexToRemove + 1);

    return mergeArrays(firstPart, secondPart);
  } else {
    return arr;
  }
}

export function mergeArrays(first, second) {
  return [...first, ...second];
}

export function formatNumber(num) {
  return (
    num &&
    Math.trunc(num)
      .toString()
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
  );
}

/*
const someObj = {person: {firstName: 'Test', lastName: 'TestLast'}};
var property = 'person.lastName';
deletePropertyPath(someObj, property); === {person: {firstName: 'Test'}};
 */
export const deletePropertyByPath = (object, path) => {
  let currentObject = object;
  let parts = path.split('.');
  const last = parts.pop();
  for (const part of parts) {
    currentObject = currentObject[part];
    if (!currentObject) {
      return;
    }
  }
  delete currentObject[last];
};
